import { render, staticRenderFns } from "./GRCActionPlanForm.vue?vue&type=template&id=66810bb7&scoped=true&"
import script from "./GRCActionPlanForm.vue?vue&type=script&lang=js&"
export * from "./GRCActionPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./GRCActionPlanForm.vue?vue&type=style&index=0&id=66810bb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66810bb7",
  null
  
)

export default component.exports